import { SiteMeta } from '@/components/site/SiteMeta';
import { sectors } from '@/content/sectors';
import { StaticBody } from '@/pages/site/StaticBody';
import { SobreBody } from '@/pages/site/content/SobreBody';
import { buildApps } from '@/seo/catalog';

export function SobrePage() {
  return (
    <>
      <SiteMeta
        title={'Sobre a Operax'}
        description={'Provedor de Tecnologia verificado pela Meta. Operax, segurança, LGPD e conformidade NGS1 (SBIS/CFM).'}
        path={'/sobre'}
      />
      <StaticBody html={SobreBody({ appsCount: buildApps.length, sectorsCount: sectors.length })} />
    </>
  );
}
